module.exports = require('./dist/Sticky');



//////////////////
// WEBPACK FOOTER
// ./~/react-stickynode/index.js
// module id = 411
// module chunks = 72138227098318 127651196306611